import { parseToRgb, rgb } from 'polished';

/**
 * Calculates the luma (perceptual brightness) of a color object.
 * This mimics LESS's luma fucntion and uses the conversion defined at
 * https://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
 *
 * @param color: string - color to calculate luma
 */
export const relativeLuminance = (color: string) => {
  const rgbColor = parseToRgb(color);

  const determineChannelRelativeLuminance = (value: number) => {
    // convert the RGB value to a fraction
    let newValue = value / 255;

    if (newValue <= 0.03928) {
      newValue = newValue / 12.92;
    } else {
      newValue = Math.pow((newValue + 0.055) / 1.055, 2.4);
    }

    return newValue * 255;
  };

  const relativeLuminance = Math.round(
    determineChannelRelativeLuminance(rgbColor.red) * 0.2126 +
      determineChannelRelativeLuminance(rgbColor.green) * 0.7152 +
      determineChannelRelativeLuminance(rgbColor.blue) * 0.0722
  );

  return rgb({
    red: relativeLuminance,
    green: relativeLuminance,
    blue: relativeLuminance,
  });
};
